var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.1 16.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5,16.12a.68.68,0,0,1-.68.66H2.73A2.69,2.69,0,0,1,0,14.16V2.62A2.68,2.68,0,0,1,2.73,0h8.4a2.69,2.69,0,0,1,2.74,2.62v3.9a.69.69,0,0,1-.71.66.68.68,0,0,1-.66-.66V2.62a1.35,1.35,0,0,0-1.37-1.31H2.73A1.33,1.33,0,0,0,1.37,2.62V14.16a1.34,1.34,0,0,0,1.36,1.31H4.31A.66.66,0,0,1,5,16.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3,4.5A.47.47,0,0,0,8.83,4H4A.47.47,0,1,0,4,5H8.83A.46.46,0,0,0,9.3,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,7.18a.47.47,0,0,0-.47-.47h-3a.47.47,0,0,0,0,.94h3A.47.47,0,0,0,7,7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38,9.4a.47.47,0,1,0,0,.93h2a.47.47,0,1,0,0-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.88,16.43a1,1,0,0,1-.73.35H9.55a1,1,0,0,1-1-1,1.23,1.23,0,0,1,0-.19,3.32,3.32,0,0,1,1.85-2.32,1.81,1.81,0,0,1-.46-1.2,1.84,1.84,0,0,1,3.68,0,1.81,1.81,0,0,1-.46,1.2,3.32,3.32,0,0,1,1.84,2.27s0,0,0,0a1,1,0,0,1-.2.8Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f5c17f31dea7f23bc51d32d942fe17e3.svg";
export { ForwardRef as ReactComponent };